export type BaselineDirection = 'up' | 'down' | 'same';

export interface IBaselineDelta {
    direction: BaselineDirection;
    /** Percent change from the baseline; null when the baseline is 0 and the value is not. */
    pct: number | null;
}

// In Compare Dates mode a field value is [current, compared, delta, deltaPct]; rows are compared on current.
const numericValue = (value: unknown): number | null => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (raw === null || raw === undefined || raw === '') return null;
    const number = typeof raw === 'number' ? raw : Number(raw);
    return Number.isFinite(number) ? number : null;
};

/** How a row's metric differs from the baseline row's. Says nothing about whether that is good. */
export function baselineDelta(value: unknown, baseline: unknown): IBaselineDelta | null {
    const current = numericValue(value);
    const base = numericValue(baseline);
    if (current === null || base === null) return null;
    if (current === base) return {direction: 'same', pct: 0};
    const direction = current > base ? 'up' : 'down';
    return {direction, pct: base === 0 ? null : Math.abs((current - base) / base) * 100};
}

export function formatBaselinePct(pct: number | null): string {
    if (pct === null) return 'n/a';
    if (pct >= 1000) return `${Math.round(pct).toLocaleString('en-US')}%`;
    return `${pct.toLocaleString('en-US', {maximumFractionDigits: 1, minimumFractionDigits: pct < 10 ? 1 : 0})}%`;
}
